const colonValidation = /^(?!.*:).*$/;
const questionValidation = /\?/g;
const andValidation = /\&/g;
export { colonValidation, questionValidation, andValidation }